import { HorizontalLine } from './horizontal-line';
export default HorizontalLine;
